export default {
    items: [
        {
            name: 'Dashboard',
            type: 'dashboard',
            route: 'dashboard',
            iconClasses: ['font-icon', 'font-icon-dashboard'],
            iconClass: 'material-icons',
            iconName: 'dashboard',
            color: 'navy',
        },
        {
            name: 'Content',
            children: [
                { name: 'Layouts', route: 'layouts', shortcut: 'layout/_' },
                { name: 'Pages', route: 'pages', type: 'page', shortcut: 'page/_' },
                { name: 'Panel library', route: 'panels', type: 'panel', shortcut: 'panel/_' },
            ],
            iconClass: 'material-icons',
            iconName: 'content_copy',
            color: 'navy',
        },
        {
            name: 'Assets',
            route: 'assets',
            type: 'asset',
            iconClass: 'material-icons',
            iconName: 'photo_album',
            color: 'navy',
        },
        {
            name: 'Staff',
            children: [
                { name: 'Staff Members', type: 'staff_member', route: 'staff_members' },
                { name: 'Departments', type: 'department', route: 'departments' },
            ],
            iconClass: 'material-icons',
            iconName: 'people',
            color: 'navy',
        },
        {

            name: 'Blog',
            children: [
                { name: 'Posts', route: 'news_posts', type: 'news_post' },
                { name: 'Categories', route: 'news_categories', type: 'news_category' },
            ],
            iconClass: 'material-icons',
            iconName: 'perm_media',
            color: 'navy',
        },
        {
            name: 'Products',
            children: [
                { name: 'Products', route: 'products', type: 'product' },
                { name: 'Categories', route: 'categories', type: 'category' },
                { name: 'Locations', route: 'locations', type: 'location' },
            ],
            iconClass: 'material-icons',
            iconName: 'store',
            color: 'navy',
        },
        // {
        //     name: 'Testimonials',
        //     route: 'testimonials',
        //     type: 'testimonial',
        //     iconClass: 'material-icons',
        //     iconName: 'format_quote',
        //     color: 'navy',
        // },
        /*{
            name: 'Staff',
            type: 'staff_member',
            route: 'staff_members',
            iconClass: 'material-icons',
            iconName: 'people',
            color: 'navy',
         },*/
        /*{
            name: 'Customers',
            type: 'customer',
            route: 'customers',
            iconClass: 'material-icons',
            iconName: 'perm_contact_calendar',
            color: 'navy',
        },*/
        {
            name: 'Enquiries',
            children: [
                { name: 'Enquiries', route: 'enquiries', type: 'enquiry' },
                { name: 'Subscribers', route: 'subscribers', type: 'subscriber' },
                { name: 'Downloads', route: 'downloads', type: 'download' },

            ],
            iconClass: 'material-icons',
            iconName: 'forum',
            color: 'navy',
        },
        {
            name: 'Accounts',
            children: [
                { name: 'Users', route: 'users', shortcut: 'user/_', type: 'user' },
                { name: 'Roles', route: 'roles', shortcut: 'role/_', type: 'role' },
            ],
            iconClass: 'material-icons',
            iconName: 'account_box',
            color: 'navy',
        },
        {
            name: 'Settings',
            children: [
                { name: 'Settings', route: 'settings', type: 'setting' },
                { name: 'Redirect URLs', route: 'redirect_urls', type: 'redirect_url' },
            ],
            iconClass: 'material-icons',
            iconName: 'settings',
            color: 'navy',
        }
    ],
    defaultItem: 'Content',
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/menu.js